import { render, staticRenderFns } from "./ag-grid-cell-renderer-component-wrapper.vue?vue&type=template&id=47b7fc74"
import script from "./ag-grid-cell-renderer-component-wrapper.vue?vue&type=script&lang=js"
export * from "./ag-grid-cell-renderer-component-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports